import type { ActionFlowState } from '../types.action-flow'

export function isActionFlowMayStillLand(state: ActionFlowState) {
  return (
    (state.flowState === 'execution' && state.stepState === 'pending-transaction') ||
    (state.flowState === 'idle' && state.isRetryBlocked === true)
  )
}
